import React, { useEffect } from "react";

export default function ContactSection() {
  useEffect(() => {
    const scriptId = "hs-form-embed";
    if (document.getElementById(scriptId)) return;

    const script = document.createElement("script");
    script.id = scriptId;
    script.src = "https://js-na2.hsforms.net/forms/embed/245065734.js";
    script.defer = true;
    document.body.appendChild(script);
  }, []);

  useEffect(() => {
    const handleMessage = (event) => {
      let data = event.data;
      if (typeof data === "string") {
        if (data.includes("onFormSubmitted") || data.includes("onFormSubmit")) {
          window.location.href = "/thank-you.html";
          return;
        }
        try {
          data = JSON.parse(data);
        } catch (error) {
          data = null;
        }
      }
      if (!data || data.type !== "hsFormCallback") return;
      if (data.eventName === "onFormSubmitted" || data.eventName === "onFormSubmit") {
        window.location.href = "/thank-you.html";
      }
    };
    window.addEventListener("message", handleMessage);
    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  useEffect(() => {
    const container = document.querySelector(".hs-form-frame");
    if (!container) return;

    let redirected = false;
    const redirectIfSubmitted = () => {
      if (redirected) return;
      const submitted =
        container.querySelector(".submitted-message") ||
        container.querySelector(".hs-form__submitted-message") ||
        container.querySelector(".hs-form .submitted-message");
      if (submitted) {
        redirected = true;
        window.location.href = "/thank-you.html";
      }
    };

    const observer = new MutationObserver(redirectIfSubmitted);
    observer.observe(container, { childList: true, subtree: true });

    const pollTimer = window.setInterval(redirectIfSubmitted, 500);

    return () => {
      observer.disconnect();
      window.clearInterval(pollTimer);
    };
  }, []);

  return (
    <section className="contact" id="contact">
      <div className="section-inner contact-inner">
        <div className="contact-copy">
          <p className="section-tag">Contact</p>
          <h2>Ready to grow your lead pipeline?</h2>
          <p>
            Tell us about your goals and we will return with a clear lead
            generation plan, channel mix, and next steps within 48 hours.
          </p>
          <div className="contact-detail">
            <span>Email</span>
            <strong>sparkdenz@gmail.com</strong>
          </div>
          <div className="contact-detail">
            <span>Location</span>
            <strong>Remote worldwide</strong>
          </div>
        </div>

        <div className="contact-form">
          <div
            className="hs-form-frame"
            data-region="na2"
            data-form-id="bad2c75c-5e8d-4d7b-b9d4-9072b90e1556"
            data-portal-id="245065734"
          ></div>
        </div>
      </div>
    </section>
  );
}
